import Col from "./Col/edit";
import Row from "./Row/edit";
import Section from "./Section/edit";
import Repeat from "./Repeat/edit";
import Header from "./Header/edit";
import Heading from "./Heading/edit";
import Footer from "./Footer/edit";
import Text from "./Text/edit";
import Content from "./Content/edit";
import Radio from "./Radio/edit";
import Panel from "./Panel/edit";
import Navbar from "./Navbar/edit";
import Markdown from "./Markdown/edit";
import ProcessButtons from "./ProcessButtons/edit";
import PDF from "./PDF/edit";
import Summary from "./Summary/edit";
import Dropdown from "./Dropdown/edit";
import Checkbox from "./Checkbox/edit";
import Input from "./Input/edit";
import OLMap from "./OLMap/edit";
import Categories from "./Categories/edit";
import ChildSelector from "./ChildSelector/edit";
import SecondGuardian from "./SecondGuardian/edit";
import InputTable from "./InputTable/edit";
import ProcessList from "./ProcessList/edit";
import Stop from "./Stop/edit";
import InlineHTML from "./InlineHTML/edit";
import Tickets from "./Tickets/edit";
import Logout from "./Logout/edit";
import EffectTable from "./EffectTable/edit";
import EffectCard from "./EffectCard/edit";
import Clone from "./Clone/edit";
import Effect from "./Effect/edit";
import QueueInfo from "./QueueInfo/edit";
import Accordion from "./Accordion/edit";
import Datasheet from "./Datasheet/edit";
import Loader from "./Loader/edit";
import QRCode from "./QRCode/edit";
import PaymentStatus from "./PaymentStatus/edit";

const edit = {
  PaymentStatus,
  Row,
  Section,
  Col,
  Repeat,
  Header,
  Heading,
  Footer,
  Text,
  Content,
  Radio,
  Panel,
  Navbar,
  Markdown,
  ProcessButtons,
  PDF,
  Summary,
  Dropdown,
  Checkbox,
  Input,
  OLMap,
  Categories,
  ChildSelector,
  SecondGuardian,
  InputTable,
  ProcessList,
  Stop,
  InlineHTML,
  Tickets,
  Logout,
  EffectTable,
  EffectCard,
  Clone,
  Effect,
  QueueInfo,
  Accordion,
  Datasheet,
  Loader,
  QRCode,
};

export default edit;
